/* eslint-disable no-undef */
(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('PartnerCompanyService', PartnerCompanyService);

  PartnerCompanyService.$inject = ['$resource'];

  function PartnerCompanyService($resource) {
    return $resource(apiUrl + '/insurance/:id', { id: '@id' }, {
      getAll: { url: apiUrl + '/partner-company/getByUser', method: 'GET', params: {}, isArray: true }
    })
  }
})();
